<template minapp='mpx' xlang='wxml'>
  <view class='es-radio custom-class' role='radio' wx:style="{{innerRadioStyle}}">
    <view 
    class="es-radio__label label-class" 
    wx:if="{{labelPosition === 'left'}}"
    bindtap="onClickLabel"
    >
      <text wx:if="{{label}}">{{label}}</text>
      <slot wx:else />
    </view>
    <view 
    class="es-radio__icon icon-class" 
    bindtap="onChange"
    wx:class="{{classnames}}"
    wx:style="{{checkedColor}}"
    >
      <slot name='icon' wx:if="{{useIconSlot}}" />
      <es-icon wx:else size='{{iconSize}}' name="check" />
    </view>
    <view 
    class="es-radio__label label-class" 
    wx:if="{{labelPosition === 'right'}}"
    bindtap="onClickLabel"
    >
      <text wx:if="{{label}}">{{label}}</text>
      <slot wx:else />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import radioGroup from '../radio-group/index?resolve'
  createComponent({
    parent: radioGroup,
    componentName: 'Radio',
    externalClasses: ['label-class', 'icon-class'],
    props: {
      useIconSlot: Boolean,
      iconSize: {
        type: Number,
        value: 14
      },
      fontSize:Number,
      color: String,
      labelPosition: {
        type: String,
        value: 'right'
      },

      shap: {
        type: String,
        value: 'round'
      },

      label: String,
      name: null,
      value: null,
      disabled: Boolean,
      iconStyle: null,
      radioStyle:Object,
    },

    computed: {
      parent() {
        return this.$ancestor('RadioGroup')
      },

      checkedColor() {
        const { color, iconStyle } = this
        if (!color) {
          return iconStyle
        }

        return {
          borderColor: color,
          backgroundColor: color,
          ...iconStyle
        }
      },
      isReadOnly() {
        const { disabled } = this.parent || {}
        return disabled || this.disabled;
      },

      classnames() {
        const { shap, name } = this
        const { value } = this.parent || this
        
        return {
          'es-radio--disabel': this.isReadOnly,
          'es-radio--checked': !this.isReadOnly && isObjectValueEqual(value,name),
          [`es-radio--${shap}`]: true
        }
      },
      innerRadioStyle() {
        return { ...this.radioStyle, fontSize:this.fontSize||this.iconSize + 'px'}
      }
    },

    methods: {
      onChange() {
        const { name } = this
        const { value } = this.parent || this
        const detail = { value: name }

        if (value === name) {
          return
        }

        if (!this.isReadOnly) {
          this.emit(this.parent, detail)
          this.emit(this, detail)
        }
        this.$trigger('click', detail)
      },

      emit(target, detail) {
        if (target && target.$trigger) {
          target.$trigger('input', detail)
          target.$trigger('change', detail)
        }
      },

      onClickLabel() {
        const { name } = this
        if (!this.isReadOnly) {
          this.onChange()
          this.$trigger('click-label', name)
        }
      }
    }
  })

  function isObjectValueEqual(a, b) {
    // 判断两个对象是否指向同一内存，指向同一内存返回true
    if(a === b){
      return true
    }else if (!a || !b){
      return false
    }else if (typeof a !== 'object' || typeof b !== 'object'){
      return false
    }
    // 获取两个对象键值数组
    let aProps = Object.getOwnPropertyNames(a)
    let bProps = Object.getOwnPropertyNames(b)
    // 判断两个对象键值数组长度是否一致，不一致返回false
    if (aProps.length !== bProps.length) return false
    // 遍历对象的键值
    for (let prop in a) {
      // 判断a的键值，在b中是否存在，不存在，返回false
      if (b.hasOwnProperty(prop)) {
        // 判断a的键值是否为对象，是则递归，不是对象直接判断键值是否相等，不相等返回false
        if (typeof a[prop] === 'object') {
          if (!isObjectValueEqual(a[prop], b[prop])) return false
        } else if (a[prop] !== b[prop]) {
          return false
        }
      } else {
        return false
      }
    }
    return true
  }
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '../icon/index'
    }
  }
</script>

 